export class AddedRevenue {
    public constructor(init?: Partial<AddedRevenue>) {
      Object.assign(this, init);
    }
        revenueAdjustmentId: number;
        dateGenerated: Date;
        revenueType: string;
        revenueTypeName: string;
        invoiceNumber: string;
        billingRate: number;
        quantity: number;
        description: string;
        comments: string;
        tax: number;
        adjust: number;
       
   }